import React from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'

const RotateLeftIcon = ({ onClick }) => <ReactSVG src='/icons/rotate-left.svg' onClick={onClick}
  beforeInjection={svg => {
    svg.setAttribute('style', 'cursor: pointer;')
  }} />

export const RotateLeftBtn = ({ onClick }) => <div className='ads-add__photos-list-view-item-rotate-btn'>
  <RotateLeftIcon onClick={onClick} />
</div>

RotateLeftBtn.propTypes = {
  onClick: PropTypes.func.isRequired
}

RotateLeftIcon.propTypes = {
  onClick: PropTypes.func.isRequired
}
